import { BottomNavigation, BottomNavigationAction, Box, Divider, Drawer, List } from "@mui/material";
import { useState } from "react";
import AppDrawerItem from "./AppDrawerItem";
import { Diversity1, Diversity2 } from "@mui/icons-material";

function AppDrawer(props) {

  const tab = props.tab
  const router = props.router;
  const narrow = props.narrow;

  const drawerWidth = '200px';

  // Function for handling when a side bar option is changed
  const handleClick = (redirect) => {
    console.log("Handle click called with " + redirect);
    const newUrl = '/' + props.consoleName + '/' + redirect;
    window.history.pushState(null, '', newUrl);
    props.setTab(redirect);
  }

  if(!narrow) {
    
  // Create items for the side bar
  let appDrawerItems = Object.keys(router).map((key) => {
    const item = router[key];
    const selected = (key === tab);
    return <>
            <AppDrawerItem
              key={key}
              title={item.title}
              selected={selected}
              redirect={key}
              icon={item.icon}
              accentColour={props.accentColour}
              consoleName={props.consoleName}
              handleClick={handleClick}
            />

            {item.separatorAfter && (
              <Divider sx={{ mx: 2 }} />
            )}
          </>
    })
    return (
      <Drawer
        variant="permanent"
        PaperProps={{
          sx: {
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
          }
        }}
      >
        <Box sx={{ overflow: 'auto', marginTop: '80px' }}>
          <List>
            {appDrawerItems}
          </List>
        </Box>
      </Drawer>
    )
  }
  else {
    return (
      <BottomNavigation 
        value={tab}
        onChange={(event, newValue) => {
          handleClick(newValue);
        }}
        sx={{
          position: 'fixed',
          bottom: 0,
          width: '100%'
        }}
      >
        {
          Object.keys(router).map((key) => {
            const item = router[key];
            return <BottomNavigationAction 
                      key={key}
                      value={key}
                      icon={item.icon} 
                      sx={{
                        minWidth: 15
                      }}
                    />
          })
        }
      </BottomNavigation>
    )
  }

}

export default AppDrawer;